import "./left-bar";
import {config} from "./config";
import {initD3Chart} from "./chart";
import {
  clearLabels,
  updateD3BarChart,
  initD3BarChart,
  removeNotificationTextfromChart,
  drawBarLoader,
  clearAxis,
  clearBarChart,
  clearBarChartArea,
  clearBarLoader,
  hackyCohortFix
} from "./bar-chart";
import {
  initD3SankeyChart,
  updateD3SankeyChart,
  clearYAxisLabels
} from "./sankey-chart";
import {clearLegend} from "./legend";
import {toTitleCase, isEmpty} from "./utilities";
import {
  performQuery,
  getFlowsMetadataQuery,
  getFlowsDegreeCountQuery,
  getFlowsDataQuery,
  getEarningsMetadataQuery,
  getEarningsDegreeCountQuery,
  getEarningsDataQuery
} from "./query-api";
import URLSearchParams from "@ungap/url-search-params";

// url string search parameters w/ polyfill
const SEARCH_PARAMS = new URLSearchParams(window.location.search);

//if navigating using the back or forward buttons, clear the UI
function reorient() {
  window.location.reload();
}

addEventListener("popstate", reorient);

// data in global scope w/ initial state
const pseoData = {};
pseoData.metadata = {};
pseoData.animationTimer = null;
pseoData.cipCodeFilter = [];
pseoData.dataType = "earnings";
pseoData.data = {};
pseoData.buttonData = [];
pseoData.flowsOptions = [];
pseoData.flowsSelectedCut = 5;
pseoData.flowsDisplay = "count";

// clears button dropdown list, adds label text, and deactivates
function deactivateDropdownButton(selector, text) {
  $j33(selector).text(text);
  if ($j33(selector).hasClass("active")) {
    $j33(selector).removeClass("active");
  }
  $j33(selector).prop("disabled", true);
}

function activateDropdownButton(selector, text) {
  selector.text(text);
  if (!selector.hasClass("active")) {
    selector.addClass("active");
  }
  $j33(selector).prop("disabled", false);
}

// resets the entire left control panel and cip code grid
function resetUI() {
  // clear the left panel and deactivate buttons
  $j33("#state-dropdown > .dropdown-list").empty();
  deactivateDropdownButton("#state-dropdown-button", "Select State");
  $j33("#institution-dropdown > .dropdown-list").empty();
  deactivateDropdownButton(
      "#institution-dropdown-button",
      "Select Institution"
  );
  $j33("#degreelevel-dropdown > .dropdown-list").empty();
  deactivateDropdownButton("#degreelevel-dropdown-button");
  $j33("#gradcohort-dropdown > .dropdown-list").empty();
  deactivateDropdownButton("#gradcohort-dropdown-button");

  // empty the cipcode grid
  $j33("#checkbox-grid").empty();
}

$j33("#clearbutton").on("click", function () {
  var button = $j33(this);
  button.addClass("disabled").css("pointer-events", "none");

  $j33("#checkbox-grid > label.active").trigger("click");
  clearLabels();
  deleteFromURL("program");

  setTimeout(function () {
    button.removeClass("disabled").css("pointer-events", "auto");
  }, 400);

  clearBarChartArea();
  clearYAxisLabels();
  //addSelectDegreeTexttoChart();

  // disable any queued clicks
  if (pseoData.degreequeue) {
    pseoData.degreequeue.forEach(i => {
      clearTimeout(i.timeoutId);
    });
  }

  return false;
});

// data type toggle init
function initDataTypeToggle() {
  // select the type parsed by the URL
  if (
      SEARCH_PARAMS.has("type") &&
      $j33(`#data-type-toggle > label > #${SEARCH_PARAMS.get("type")}-radio`)
          .length > 0
  ) {
    let type = SEARCH_PARAMS.get("type");
    $j33(`#data-type-toggle > label > #${type}-radio`).trigger("click");
  } else {
    $j33("#data-type-toggle > label > #earnings-radio")
        .parent()
        .trigger("click");
  }
}

// toggle whether the detailed program button is available and clickable
function allowDetailedPrograms(allow) {
  if (allow) {
    // allow for detailed cip codes
    $j33("#four-digit-cip-label").removeClass("disabled")
    $j33("#four-digit-cip-label").prop("title", "Show Detailed Degree Categories (4-digit CIP Codes)")
    $j33("#four-digit-cip-label").prop('disabled', false);
  } else {
    // block detailed cip codes
    $j33("#four-digit-cip-label").addClass("disabled")
    $j33("#four-digit-cip-label").prop("title", "Detailed Degree Categories (4-digit CIP Codes) Not Published for all Flows, Masters Earnings, or PhD Research Earnings")
    $j33("#four-digit-cip-label").prop('disabled', true);
    $j33(`#two-digit-cip-toggle`).trigger("click");
    pseoData.cipLevel = '2'
  }
}

//data type toggle control
$j33("#data-type-toggle > label").change(function () {
  pseoData.dataType = $j33(this)
      .attr("id")
      .replace("-label", "");
  updateURL("type", pseoData.dataType);
  resetUI(); // reset the UI
  clearBarChart(); // reset the bar chart
  clearLegend(); // reset the legend
  //init the chart area
  initChartType(pseoData);
  // draw the loading animation in chart
  pseoData.animationTimer = drawBarLoader(pseoData.animationTimer);

  // set the 4-digit cip button as disabled if flows, enabled if earns
  if (pseoData.dataType === "earnings") {
    allowDetailedPrograms(true)
  } else {
    allowDetailedPrograms(false)
  }

  // init the left panel setup
  setupStateDropdown(pseoData.metadata, pseoData.dataType);
});

//default label ver the 3 radio button options
function initRadioLabel() {
  $j33("#radioLabel").html(function () {
    var selected = $j33("input[name=radioName]:checked", "#twotoggle").attr(
        "id"
    );
    pseoData.analysis_type = selected;
    return toTitleCase(selected.replace("_", " ")) + " Filter";
  });
}

// get label categories based on the 2 option toggle box
function threeRadioLabels(labelid, radioid) {
  var returnVal;
  if (labelid === "earnings-percentile") {
    switch (radioid) {
      case "radioselect1":
        returnVal = 25;
        break;
      case "radioselect2":
        returnVal = 50;
        break;
      case "radioselect3":
        returnVal = 75;
    }
  } else if (labelid === "years-postgrad") {
    switch (radioid) {
      case "radioselect1":
        returnVal = 1;
        break;
      case "radioselect2":
        returnVal = 5;
        break;
      case "radioselect3":
        returnVal = 10;
    }
  }

  return returnVal;
}

function initTwoToggle() {
  // select the type parsed by the URL
  if (SEARCH_PARAMS.has("compare")) {
    let paramVal = SEARCH_PARAMS.get("compare");
    if (
        paramVal === "postgrad" &&
        $j33(`#twotoggle > #clock-button`).length > 0
    ) {
      $j33(`#twotoggle > #clock-button`).trigger("click");
    } else if (
        paramVal === "percentile" &&
        $j33(`#twotoggle > #percent-button`).length > 0
    ) {
      $j33(`#twotoggle > #percent-button`).trigger("click");
    } else {
      $j33(`#twotoggle > #clock-button`).trigger("click");
    }
  } else {
    $j33(`#twotoggle > #clock-button`).trigger("click");
  }
}

//onclick label over the 3 radio button options
$j33("#twotoggle > label").on("click", function () {
  // set the URL parameter
  let buttonName = $j33(this).attr("id");
  if (buttonName === "clock-button") {
    updateURL("compare", "postgrad");
  } else if (buttonName === "percent-button") {
    updateURL("compare", "percentile");
  }

  if ($j33(this).hasClass("active")) {
    return false;
  }

  $j33('#twotoggle input[type="radio"]')
      .not(":checked")
      .prop("checked", true);

  $j33("#twotoggle .active")
      .not($j33(this))
      .removeClass("active");

  // color all non checked svg
  $j33("#twotoggle label")
      .children("svg")
      .removeClass("icon-toggle-active")
      .addClass("icon-toggle-inactive");

  $j33(this).toggleClass("active");
  // color the svg based on bootstrap button
  $j33(this)
      .children("svg")
      .removeClass("icon-toggle-inactive")
      .addClass("icon-toggle-active");

  // change the label of the 3 radio option
  let selected = $j33(this)
      .children("input:first")
      .attr("id");
  pseoData.analysis_type = selected;
  $j33("#radioLabel").html(toTitleCase(selected) + " Filter");

  labelRadios();
  if (pseoData.metadata.earnings_availability) {
    //hacky fix to load the URL/default settings once availability data is loaded
    processRadiosClicks();
  }
  renderChart(pseoData);

  return false;
});

function flowsLabelRadios({yearspostgradAvailable}) {
  $j33("#flows-selected-cut > label > input").each(function () {
    let thisYears = parseInt(this.id.replace("-yearspostgrad", ""));
    let element = $j33(this).parent();
    if (yearspostgradAvailable.includes(thisYears)) {
      element.prop("disabled", false);
      element.removeClass("disabled");
      element.css("pointer-events", "auto");
    } else {
      element.prop("disabled", true);
      element.addClass("disabled");
      element.css("pointer-events", "none");
    }
  });

  // select URL input OR
  // maintain the selected year postgrad filter if available
  // otherwise default to mid, otherwise first item
  if (
      SEARCH_PARAMS.has("type") &&
      SEARCH_PARAMS.get("type") === "flows" &&
      SEARCH_PARAMS.has("filter") &&
      $j33(`#flows-selected-cut > label > span`).filter(function () {
        return $j33(this).text() === SEARCH_PARAMS.get("filter");
      }).length > 0 &&
      !$j33(`#flows-selected-cut > label > span`)
          .filter(function () {
            return $j33(this).text() === SEARCH_PARAMS.get("filter");
          })
          .parent()
          .prop("disabled")
  ) {
    let param = SEARCH_PARAMS.get("filter");
    $j33("#flows-selected-cut > label > span")
        .filter(function () {
          return $j33(this).text() === param;
        })
        .parent()
        .trigger("click")
        .blur();
  } else if (
      yearspostgradAvailable.includes(parseInt(pseoData.flowsSelectedCut))
  ) {
    $j33("#flows-selected-cut > label > span")
        .filter(function () {
          return $j33(this).text() === pseoData.flowsSelectedCut;
        })
        .parent()
        .trigger("click")
        .blur();
  } else if (yearspostgradAvailable.includes(5)) {
    let btn = $j33("#flows-selected-cut").find("#five-button");
    btn.trigger("click").blur();
    pseoData.flowsSelectedCut = parseInt(btn.children("span").text());
  } else {
    let btn = $j33("#flows-selected-cut label:first-child");
    btn.trigger("click").blur();
    pseoData.flowsSelectedCut = parseInt(btn.children("span").text());
  }
  updateURL("filter", pseoData.flowsSelectedCut);
}

function labelRadios() {
  //labels in 3 radio buttons
  $j33("#threetoggle label").each(function () {
    var input = $j33(this).children("input");
    var radioid = input.attr("id");
    var labelid = $j33("input[name=radioName]:checked", "#twotoggle").attr(
        "id"
    );

    var labeltext = threeRadioLabels(labelid, radioid);
    $j33(this)
        .children("span")
        .html(labeltext);

    //if label is for postgrad_years and isn't available, disable
    if (
        labelid === "years-postgrad" &&
        !($j33.inArray(Number(labeltext), pseoData.yearspostgradAvailable) >= 0)
    ) {
      input.prop("disabled", true);
      $j33(this).addClass("disabled");
      $j33(this).css("pointer-events", "none");
    } else {
      input.prop("disabled", false);
      $j33(this).removeClass("disabled");
      $j33(this).css("pointer-events", "auto");
    }

    // set the title for each property
    if (labelid === "years-postgrad") {
      var plural = "";
      if (labeltext !== "1") {
        plural = "s";
      }
      $j33(this).prop(
          "title",
          "Filter by " + labeltext + " Year" + plural + " Postgrad"
      );
    } else {
      $j33(this).prop(
          "title",
          "Filter by " + labeltext + "th Earnings Percentile"
      );
    }
  });
}

//onclick degree sorting
pseoData.cipSortOrder = "cellcount-order";
$j33("#sort-order-toggle label").on("click", function () {
  if ($j33(this).hasClass("active")) {
    return false;
  }

  pseoData.cipSortOrder = $j33(this)
      .children('input[type="radio"]')
      .attr("id");

  $j33(this)
      .children('input[type="radio"]:first')
      .prop("checked", true);

  $j33("#sort-order-toggle label")
      .not($j33(this))
      .removeClass("active");

  $j33("#sort-order-toggle label")
      .children("svg")
      .removeClass("icon-toggle-active")
      .addClass("icon-toggle-inactive");

  $j33(this).toggleClass("active");
  $j33(this)
      .children("svg")
      .removeClass("icon-toggle-inactive")
      .addClass("icon-toggle-active");

  setupDegreeButtons(pseoData.buttonData);

  return false;
});

//onclick 3 radio button refilter and draw
$j33("#threetoggle label").on("click", function () {
  let filter = $j33(this)
      .children("span")
      .text();

  updateURL("filter", filter);
  if ($j33(this).hasClass("active")) {
    return false;
  }

  $j33(this)
      .children('input[type="radio"]:first')
      .prop("checked", true);

  $j33("#threetoggle label")
      .not($j33(this))
      .removeClass("active");

  $j33(this).toggleClass("active");

  pseoData.selected_cut = $j33(this)
      .children("span")
      .html();
  renderChart(pseoData);

  updateDegreeButtons(pseoData);

  return false;
});


function initCipLevel() {
  // if the data type is earnings and is set to 2 or 4 digit cip
  // respect the input, otherwise default to 2 digit and reset the url param
  if (SEARCH_PARAMS.has("specificity") &&
      SEARCH_PARAMS.has("type") &&
      SEARCH_PARAMS.get("type") === 'earnings' &&
      (SEARCH_PARAMS.get("specificity") === '2') ||
      SEARCH_PARAMS.get("specificity") === '4') {
    pseoData.cipLevel = SEARCH_PARAMS.get("specificity");
  } else {
    pseoData.cipLevel = '2'; // default to 2 digit
    updateURL("specificity", pseoData.cipLevel) // set the url param
  }

  if (pseoData.cipLevel === '4') {
    $j33(`#four-digit-cip-label`).addClass("active");
    $j33(`#two-digit-cip-label`).removeClass("active");
  }

}


$j33("#cip-level-toggle label").on("click", function () {
  // don't do anyting if the toggle is already active
  if ($j33(this).hasClass("active") || $j33(this).hasClass("disabled")) {
    return false;
  }

  // get the radio id name
  let cipLevelText = $j33(this)
      .children('input[type="radio"]')
      .attr("id");

  // set the cip level filter
  pseoData.cipLevel = cipLevelText === "four-digit-cip-toggle" ? '4' : '2';

  // set the url param
  updateURL("specificity", pseoData.cipLevel)

  // redraw the buttons
  setupDegreeButtons(pseoData.buttonData);
})


function processRadiosClicks() {
  if (
      SEARCH_PARAMS.has("filter") &&
      $j33(`#threetoggle > label > span`).filter(function () {
        return $j33(this).text() === SEARCH_PARAMS.get("filter");
      }).length > 0 &&
      !$j33(`#threetoggle > label > span`)
          .filter(function () {
            return $j33(this).text() === SEARCH_PARAMS.get("filter");
          })
          .parent()
          .hasClass("disabled")
  ) {
    let param = SEARCH_PARAMS.get("filter");
    pseoData.selected_cut = param;
    $j33(`#threetoggle > label > span`)
        .filter(function () {
          return $j33(this).text() === param;
        })
        .parent()
        .trigger("click");
  } else {
    //set default as the 2nd option if not disabled, otherwise select 1st
    $j33("#threetoggle > label")
        .children("input")
        .each(function () {
          if (
              !$j33(this).is(":disabled") &&
              $j33(this).attr("id") === "radioselect2"
          ) {
            $j33("#threetoggle > label").removeClass("active");
            $j33(this)
                .parent()
                .addClass("active");
            pseoData.selected_cut = $j33(this)
                .parent()
                .children("span")
                .html();
            updateURL("filter", pseoData.selected_cut);
          } else if ($j33(this).attr("id") === "radioselect1") {
            $j33("#threetoggle > label").removeClass("active");
            $j33(this)
                .parent()
                .addClass("active");
            pseoData.selected_cut = $j33(this)
                .parent()
                .children("span")
                .html();
            updateURL("filter", pseoData.selected_cut);
          }
        });
  }
}

function initFlowsOptions() {
  let key = "destination";
  //url parameter handling - only updates the
  if (SEARCH_PARAMS.has(key)) {
    if (SEARCH_PARAMS.get(key) === "none") {
      pseoData.flowsOptions = [];
      $j33(`#flowstoggle > button`).removeClass("active");
    } else {
      let paramArray = SEARCH_PARAMS.get(key).split(",");
      paramArray.forEach(param => {
        $j33(`#flowstoggle > #${param}-button`).addClass("active");
        if (!pseoData.flowsOptions.includes(param)) {
          pseoData.flowsOptions.push(param);
        }
      });
    }
  } else if (
      pseoData.flowsOptions.includes("industry") ||
      pseoData.flowsOptions.includes("geography")) {
    // if ind or geo are already active set the display state
    if (pseoData.flowsOptions.includes("industry")) {
      $j33(`#flowstoggle > #industry-button`).addClass("active");
    }
    if (pseoData.flowsOptions.includes("geography")) {
      $j33(`#flowstoggle > #geography-button`).addClass("active");
    }
  } else {
    // set the default state
    $j33(`#flowstoggle > #industry-button`).addClass("active");
    pseoData.flowsOptions = ["industry"];
    updateURLMultivalue(key, "industry");
  }
}

$j33("#flows-display > button").click(function () {
  let id = this.id;
  if ($j33(this).hasClass("active")) {
    return false;
  }
  let buttonType = id.replace("-button", "");
  pseoData.flowsDisplay = buttonType;
  $j33(`#flows-display > button`)
      .not(`#${id}`)
      .removeClass("active");
  $j33(`#flows-display > button #${id}`).addClass("active");
  updateURL("display", pseoData.flowsDisplay);
  renderChart(pseoData);
});

function initFlowsDisplay() {
  let key = "display";
  if (SEARCH_PARAMS.has(key)) {
    let param = SEARCH_PARAMS.get(key);
    pseoData.flowsDisplay = param === "share" ? "share" : "count";
  } else {
    pseoData.flowsDisplay = "count";
  }
  updateURL("display", pseoData.flowsDisplay);
  $j33(`#flows-display > #${pseoData.flowsDisplay}-button`).trigger("click");
}

$j33("#flowstoggle > button").click(function (event) {
  // toggle which dimensions to show in the flows data
  // update url to reflect changes
  let buttonType = this.id.replace("-button", "");
  if (buttonType === "industry" || buttonType === "geography") {
    if (pseoData.flowsOptions.includes(buttonType)) {
      pseoData.flowsOptions = pseoData.flowsOptions.filter(
          obj => obj !== buttonType
      );
      deleteFromURLMultivalue("destination", buttonType);
    } else {
      pseoData.flowsOptions.push(buttonType);
      updateURLMultivalue("destination", buttonType);
    }
  }
  // if both buttons are deselected, save value in url
  if (pseoData.flowsOptions.length === 0) {
    updateURLMultivalue("destination", "none");
  } else {
    deleteFromURLMultivalue("destination", "none");
  }

  // refilter the cip data incase it changed on user click events
  pseoData.cipCodeData = pseoData.data.filter(function (e) {
    return this.indexOf(e.cipcode) !== -1;
  }, pseoData.cipCodeFilter.map(obj => obj.cipCode));

  // re render the data on change
  renderChart(pseoData);
});

$j33("#flows-selected-cut input:radio").change(function () {
  pseoData.flowsSelectedCut = parseInt(
      $j33(this)
          .parent()
          .children("span")
          .html()
  );
  renderChart(pseoData);
  updateURL("filter", pseoData.flowsSelectedCut);
  updateDegreeButtons(pseoData);
  return false;
});

pseoData._updateTimeout = null;

function redrawChart() {
  if (pseoData.animationTimer) {
    // if the animation is active, resize it
    if (pseoData.dataType === "earnings") {
      initD3BarChart();
      pseoData.animationTimer = drawBarLoader(pseoData.animationTimer);
    } else {
      initD3SankeyChart();
      pseoData.animationTimer = drawBarLoader(pseoData.animationTimer);
    }
  } else {
    pseoData.dataType === "earnings" ? initD3BarChart() : initD3SankeyChart();
  }
  //update (hacky fix because draw not repositioning the data)
  renderChart(pseoData);
}

// debounce the rerendering
let resizeId;
$j33(window).on("resize", function () {
  clearTimeout(resizeId);
  resizeId = setTimeout(redrawChart, 250);
});

$j33(".btn-group").on("input", "change", function () {
  var checkbox = $j33(this);
  var label = checkbox.parent("label");
  if (checkbox.is(":checked") && !label.is("disabled")) {
    label.addClass("active");
  } else {
    label.removeClass("active");
  }
});

function updateURL(key, value) {
  // add to or update the url parameters
  SEARCH_PARAMS.set(key, value);
  history.pushState(
      null,
      "",
      `?${SEARCH_PARAMS.toString().replace(/%2C/g, ",")}`
  );
}

function updateURLMultivalue(key, value) {
  let delim = ",";
  // append a multivalue parameter e.g. ?param=foo&bar&baz
  if (SEARCH_PARAMS.has(key)) {
    let existingParam = SEARCH_PARAMS.get(key);
    let existingParamParts = existingParam.split(delim);
    // filter out empty strings
    existingParamParts = existingParamParts.filter(Boolean);

    if (existingParamParts.includes(value)) {

    } else {
      existingParamParts.push(value);
      SEARCH_PARAMS.set(key, existingParamParts.join(delim));
      history.pushState(
          null,
          "",
          `?${SEARCH_PARAMS.toString().replace(/%2C/g, ",")}`
      );
    }
  } else updateURL(key, value);
}

function deleteFromURL(key) {
  SEARCH_PARAMS.delete(key);
  history.pushState(
      null,
      "",
      `?${SEARCH_PARAMS.toString().replace(/%2C/g, ",")}`
  );
}

function deleteFromURLMultivalue(key, value) {
  if (!SEARCH_PARAMS.has(key)) {

  } else {
    let delim = ",";
    // remove a multivalue parameter e.g. ?param=foo&bar&baz
    let existingParam = SEARCH_PARAMS.get(key);
    let existingParamParts = existingParam.split(delim);
    // filter out empty strings
    existingParamParts = existingParamParts.filter(Boolean);
    if (!existingParamParts.includes(value)) {

    } else {
      if (existingParamParts.length === 1) {
        // if the last parameter available
        deleteFromURL(key);
      } else {
        // if there are remainder parameters
        let updatedParamParts = existingParamParts.filter(v => {
          return v !== value;
        });
        SEARCH_PARAMS.set(key, updatedParamParts.join(delim));
        history.pushState(
            null,
            "",
            `?${SEARCH_PARAMS.toString().replace(/%2C/g, ",")}`
        );
      }
    }
  }
}

function updateDegreeButtons({buttonData}) {
  if (isEmpty(buttonData)) {
    return; //shortcut if is empty
  }
  // update the button hoverover text with the grad count
  buttonData.forEach(obj => {
    let btn = $j33(`#checkbox-grid > label > #${obj.cipcode}`).parent();
    let val = obj[pickGradCountAttr(pseoData)]
        ? `${obj[pickGradCountAttr(pseoData)].toLocaleString()} Graduates`
        : `Graduate Count Suppressed`;
    btn.prop("title", `${obj.cipcode_label} - ${val}`);
  });
}

// generate the degree buttons
function generateDegreeButton(degreeAndCount) {
  // generate a label/checkbox for each degree/major
  let checkboxElement = document.createElement("label");
  checkboxElement.className =
      "btn btn-outline-secondary custom-btn census-font";
  let val = degreeAndCount[pickGradCountAttr(pseoData)]
      ? `${degreeAndCount[
          pickGradCountAttr(pseoData)
          ].toLocaleString()} Graduates`
      : `Graduate Count Suppressed`;
  checkboxElement.title = `${degreeAndCount.cipcode_label} - ${val}`;
  checkboxElement.setAttribute("data-cip-level", degreeAndCount.cip_level)

  let checkboxTextDiv = document.createElement("div");
  checkboxTextDiv.innerHTML = degreeAndCount.cipcode_label;
  checkboxTextDiv.className = "label";
  checkboxElement.appendChild(checkboxTextDiv);

  let inputElement = document.createElement("input");
  inputElement.type = "checkbox";
  inputElement.className = "hiddenCheckbox"
  inputElement.setAttribute("autocomplete", "off");
  inputElement.id = degreeAndCount.cipcode;
  checkboxElement.appendChild(inputElement);

  return checkboxElement;
}

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

function checkURLParam(param) {
  return (
      SEARCH_PARAMS.has(param) &&
      $j33(`#${param}-dropdown > .dropdown-list > #${SEARCH_PARAMS.get(param)}`)
          .length > 0
  );
}

function clickURLParam(param) {
  $j33(
      `#${param}-dropdown > .dropdown-list > #${SEARCH_PARAMS.get(param)}`
  ).trigger("click");
}

function initChartType(pseoData) {
  if (pseoData.dataType === "earnings") {
    initD3BarChart(pseoData);
  } else if (pseoData.dataType === "flows") {
    initD3SankeyChart(pseoData);
  }
}

function renderChart(pseoData) {
  clearBarLoader(pseoData.animationTimer);
  if (pseoData.dataType === "earnings") {
    updateD3BarChart(pseoData);
  } else if (pseoData.dataType === "flows") {
    updateD3SankeyChart(pseoData);
  }
}

export function pickGradCountAttr({
                                    dataType,
                                    analysis_type,
                                    selected_cut,
                                    flowsSelectedCut
                                  }) {
  // this function determines which count of grads should be used to
  // label/sort buttons depending on the datatype, analysis type, and selected cut
  // of the displayed data

  if (dataType === "earnings") {
    if (analysis_type === "earnings-percentile") {
      return `max_grads`;
    } else {
      return `y${selected_cut}_grads`;
    }
  } else {
    return `y${flowsSelectedCut}_grads`;
  }
}

function setupDegreeButtons(degreesAndCountsRaw) {
  // degrees are titlecased on input
  // button ids are the valid version of the title (this was a dumb idea)
  // label html is an <input ...> tag followed by the titlecased degree name

  let degreesAndCounts = degreesAndCountsRaw.filter(d => d.cip_level === 'A' || d.cip_level === pseoData.cipLevel)

  // clear out the existing buttons
  const checkboxGrid = $j33("#checkbox-grid");
  checkboxGrid.empty();

  // clear out existing search;
  $j33("#degree-search").val("");

  // display titlecased degree text, display all category first always
  // remove the all category and insert first
  let allIndex = findWithAttr(degreesAndCounts, "cipcode", "00");
  let allDegreesAndCount;
  if (allIndex > -1) {
    allDegreesAndCount = degreesAndCounts.splice(allIndex, 1)[0];
    $j33("#checkbox-grid").append(generateDegreeButton(allDegreesAndCount));
  }

  // display the rest of the degrees in sorted order
  if (pseoData.cipSortOrder == "alpha-order") {
    let alphaSort = degreesAndCounts.sort((a, b) =>
        a.cipcode_label.localeCompare(b.cipcode_label)
    );
    alphaSort.forEach(degCountObj =>
        $j33("#checkbox-grid").append(generateDegreeButton(degCountObj))
    );
  } else {
    // append the non null degrees in sorted order
    let gradSort = degreesAndCounts.sort((a, b) => b.max_grads - a.max_grads);
    gradSort.forEach(degCountObj =>
        $j33("#checkbox-grid").append(generateDegreeButton(degCountObj))
    );
  }

  // add 'all' degrees back to beginning of list
  if (!isEmpty(allDegreesAndCount)) {
    degreesAndCounts.unshift(allDegreesAndCount);
  }

  // if a degree button is toggled, add the cip ID to the filter and update d3
  $j33(".custom-btn").on("click", function (e) {
    e.preventDefault();
    let check_box = $j33(this).children("input");
    let checked = $j33(this).hasClass("active");
    let cipCode = check_box.attr("id");
    let labelButton = check_box.parent("label");
    let labelText = labelButton.children(".label").html();

    //disable clicking and reenable after .4 seconds to prevent rapidclick
    labelButton.addClass("disabled").css("pointer-events", "none");
    //block rapid button clicking
    setTimeout(function () {
      labelButton.removeClass("disabled").css("pointer-events", "auto");
    }, 400);

    if (checked) {
      // if unchecked, remove from filter
      check_box.data("checked", false);
      pseoData.cipCodeFilter = pseoData.cipCodeFilter.filter(
          item => item.cipCode !== cipCode
      );
      deleteFromURLMultivalue("program", cipCode);
    } else if (
        pseoData.cipCodeFilter.filter(obj => {
          return obj.cipCode === cipCode;
        }).length === 0
    ) {
      // if checked and not already in the filter push it in
      check_box.data("checked", true);
      pseoData.cipCodeFilter.push({
        cipCode: cipCode,
        cipCodeLabel: labelText
      });
      updateURLMultivalue("program", cipCode);
    }

    // clear any notification text in the d3 chart area
    removeNotificationTextfromChart();

    // filter the api data with user selected cips
    pseoData.cipCodeData = pseoData.data.filter(function (e) {
      return this.indexOf(e.cipcode) !== -1;
    }, pseoData.cipCodeFilter.map(obj => obj.cipCode));

    labelButton.toggleClass("active");

    //render chart area
    renderChart(pseoData);

    return false;
  });

  // check if the current filter can be carried over
  // same logic is used below if changed
  let degreeFound = pseoData.cipCodeFilter.some(p => {
    return degreesAndCounts.some(q => {
      // if swapping between 4dig w/ XX and 2dig
      // or 2 sets of 4dig w/ XX
      let pFilter = p.cipCode.replace("XX", "");
      let qFilter = q.cipcode.replace("XX", "");
      if (pFilter.length === qFilter.length) {
        return pFilter === qFilter;
      } else {
        // if swapping between 2 and 4 dig
        return p.cipCode.substring(0, 2) === q.cipcode.substring(0, 2);
      }
    });
  });

  // check if a URL parameter can be used
  if (checkURLProgramsAvailable()) {
    let params = SEARCH_PARAMS.get("program");
    let paramArray = params.split(",");

    // toggle on program if possible, disable otherwise
    paramArray.forEach(param => {
      let selector = $j33(`#checkbox-grid > label > #${param}`);
      if (selector.length > 0) {
        selector.parent().trigger("click");
      } else {
        // delete from the URL and active filter
        deleteFromURLMultivalue("program", param);
        pseoData.cipCodeFilter = pseoData.cipCodeFilter.filter(
            obj => obj.cipCode !== param
        );
      }
    });
  } else if (isEmpty(pseoData.cipCodeFilter) || !degreeFound) {
    // if no filter is active or if no filter can be carried over, select some degrees
    pseoData.cipCodeFilter = [];
    pseoData.degreequeue = [];
    deleteFromURL("program");

    // if there is only an 'all' and a single cip, select the one cip
    if ($j33("#checkbox-grid > label").length === 2) {
      $j33("#checkbox-grid > label > input:last").trigger("click");
    } else {
      //select first 3 degrees
      let inputs = $j33("#checkbox-grid > label > input");

      if (pseoData.dataType === "earnings") {
        inputs = inputs.slice(1, 3); // earnings, show all by default
      } else {
        inputs = inputs.slice(1, 2); // if flows, don't
      }
      inputs.each(function (index, value) {
        //set on input lag to mimic interactivity
        let delayclick = setTimeout(function () {
          $j33(value).trigger("click");
        }, 500 * index);

        let clickMap = {id: this.id, timeoutId: delayclick};
        pseoData.degreequeue.push(clickMap);
      });
    }

    // if a filter is already active, select available degrees from existing
  } else {
    // * FIXME: clean up logic below

    // reset the program parameters so mixed lengths arent carried
    deleteFromURL("program");

    // keep a temp degree filter and clear the global one
    let tempCipCodeFilter = pseoData.cipCodeFilter;
    pseoData.cipCodeFilter = [];

    // keep track of the matched degrees so they can be clicked only once
    let matched = [];
    let orderBy = null; // track order of cips in chart
    // click available degrees thus adding them to the global filter
    tempCipCodeFilter.forEach(p => {
      // if the degree exists in the selection, click it
      let matchedPerFilter = degreesAndCounts.filter(q => {
        // for some reason 2 digit rollups use 4 digits with an XX rather than 2
        // strip them out as they're dumb
        let pFilter = p.cipCode.replace("XX", "");
        let qFilter = q.cipcode.replace("XX", "");
        if (pFilter.length === qFilter.length) {
          // if cipcodes are at the same 2/4 level, reselect identical
          if (orderBy) {
            orderBy = null;
          }
          return pFilter === qFilter;
        } else {
          // if swapping between 2/4 level match by first digits only
          if (!orderBy) {
            orderBy =
                pseoData.cipSortOrder === "cellcount-order"
                    ? "grads"
                    : "cipcode_label";
          }
          return p.cipCode.substring(0, 2) === q.cipcode.substring(0, 2);
        }
      });
      matchedPerFilter.forEach(m => {
        if (!matched.some(p => p.cipcode === m.cipcode)) {
          matched.push(m);
        }
      });
    });

    // select all maintained degrees
    if (matched) {
      if (orderBy) {
        // if ordered, sort the matched list
        if (orderBy === "grads") {
          matched.sort((a, b) => (a[orderBy] < b[orderBy] ? 1 : -1));
        } else {
          matched.sort((a, b) => a[orderBy].localeCompare(b[orderBy]));
        }
      }
      matched.forEach(m => {
        $j33("#checkbox-grid > label > #" + m.cipcode).trigger("click");
      });
    }
  }
  removeFocus();
}

function checkURLProgramsAvailable() {
  // if one of the cipcodes is available then the URL params can be used
  if (SEARCH_PARAMS.has("program")) {
    let returnVal = false;
    let params = SEARCH_PARAMS.get("program");
    // 00 is always available, dont consider it
    let paramArray = params.split(",").filter(p => p !== "00");
    paramArray.forEach(param => {
      if ($j33(`#checkbox-grid > label > #${param}`).length > 0) {
        returnVal = true;
      }
    });
    return returnVal;
  } else {
    return false;
  }
}

function getPSEOData({dataType, institution, degree_level, grad_cohort_id}) {
  let promises = [];
  if (dataType === "earnings") {
    promises = [
      performQuery(
          getEarningsDataQuery(institution, degree_level, grad_cohort_id)
      ),
      performQuery(
          getEarningsDegreeCountQuery(institution, degree_level, grad_cohort_id)
      )
    ];
  } else if (dataType === "flows") {
    promises = [
      performQuery(
          getFlowsDataQuery(institution, degree_level, grad_cohort_id)
      ),
      performQuery(
          getFlowsDegreeCountQuery(institution, degree_level, grad_cohort_id)
      )
    ];
  } else {
    throw new Error(`Unrecognized fetch request for data type: ${dataType}`);
  }

  return Promise.all(promises);
}

function createNoDataDropdownElement() {
  let noDataElement = document.createElement("a");
  noDataElement.id = "nodata";
  noDataElement.className = "dropdown-item disabled";
  noDataElement.setAttribute("style", "display:none;");
  noDataElement.innerHTML = "No results found";
  return noDataElement;
}

function setupCohortDropdown(gradcohortsMetadata) {
  $j33("#gradcohort-dropdown > .dropdown-list").empty();
  $j33("#gradcohort-dropdown > form > input").val("");

  // determine the 'best' cohort to use as a default selection
  // see below in this block fo description of years_avail var
  let maxGradCohortYearsAvail = Math.max(
      ...gradcohortsMetadata.map(o => o.grad_cohort_years_avail),
      0
  );
  let goodCohorts = gradcohortsMetadata.filter(
      cohort => cohort.grad_cohort_years_avail === maxGradCohortYearsAvail
  );
  const maxGoodGradCohort = Math.max(
      ...goodCohorts.map(o => +o.grad_cohort, 0)
  );

  // if the all category is an available cohort, use it as the default selection
  let bestGradCohort = goodCohorts.find(v => v.grad_cohort === "0000");
  // otherwise pick a representative one from the list
  if (!bestGradCohort) {
    bestGradCohort = goodCohorts.filter(
        cohort => +cohort.grad_cohort === maxGoodGradCohort
    )[0];
  }
  let cohortLabelSort = gradcohortsMetadata.sort((a, b) =>
      a.grad_cohort_label.localeCompare(b.grad_cohort_label)
  );
  cohortLabelSort.forEach(function (obj) {
    let dropdownElement = document.createElement("a");
    dropdownElement.className = "dropdown-item";
    dropdownElement.id = obj.grad_cohort_id;
    dropdownElement.innerHTML = obj.grad_cohort_label;
    $j33("#gradcohort-dropdown > .dropdown-list").append(dropdownElement);
  });

  let noDataElement = createNoDataDropdownElement();
  $j33("#gradcohort-dropdown > .dropdown-list").append(noDataElement);

  // allow selection of cohorts
  $j33("#gradcohort-dropdown-button").removeAttr("disabled");

  let dropdownButton = $j33("#gradcohort-dropdown-button");
  activateDropdownButton(dropdownButton);

  $j33("#gradcohort-dropdown > .dropdown-list > a").click(function () {
    pseoData.grad_cohort_id = this.id;

    // change the dropdown to show the cohort
    dropdownButton.html(this.innerHTML);
    updateURL("gradcohort", this.id);
    hackyCohortFix();

    // start the bar animation
    removeNotificationTextfromChart();
    pseoData.animationTimer = drawBarLoader(pseoData.animationTimer);

    //get the actual data and degreeholder counts from the API
    //store the earnings/flows data
    //setup the list of degree buttons
    getPSEOData(pseoData)
        .then(response => {
          // clear the bar animation
          clearBarLoader(pseoData.animationTimer);

          //store the pseo earnings/flows data from the api
          const dataResponse = response.find(obj =>
              obj.data.hasOwnProperty(`${pseoData.dataType}_data`)
          );
          pseoData.data = dataResponse?.data?.[`${pseoData.dataType}_data`] || [];

          //pass the count of degreeholders to setup cip buttons
          const buttonResponse = response.find(obj =>
              obj.data.hasOwnProperty(`${pseoData.dataType}_degreecount`)
          );
          pseoData.buttonData = buttonResponse?.data?.[`${pseoData.dataType}_degreecount`] || [];

          if (pseoData.data.length === 0 || pseoData.buttonData.length === 0) {
            pseoData.cipCodeFilter = [];
            pseoData.cipCodeData = [];
            deleteFromURL("program");
          }

          setupDegreeButtons(pseoData.buttonData);
          if (pseoData.data.length === 0 || pseoData.buttonData.length === 0) {
            renderChart(pseoData);
          }
        })
        .catch(err => console.log(err));

    // leftover from initial app, used to label radios (needs to be reimplemented)
    // the grad_cohort_years_avail is flagged like unix permissions
    // 1 = 1 year postgrad available
    // 2 = 5 year postgrad available
    // 4 = 10 year postgrad available
    let selectedCohort = gradcohortsMetadata.filter(
        cohort => cohort.grad_cohort_id === this.id
    )[0];
    pseoData.yearspostgradAvailable = [];
    if ([1, 3, 5, 7].includes(selectedCohort.grad_cohort_years_avail)) {
      pseoData.yearspostgradAvailable.push(1);
    }
    if ([2, 3, 6, 7].includes(selectedCohort.grad_cohort_years_avail)) {
      pseoData.yearspostgradAvailable.push(5);
    }
    if ([4, 5, 6, 7].includes(selectedCohort.grad_cohort_years_avail)) {
      pseoData.yearspostgradAvailable.push(10);
    }

    cleanURLSearchParams();
    if (pseoData.dataType === "earnings") {
      labelRadios();
      processRadiosClicks();
    } else if (pseoData.dataType === "flows") {
      flowsLabelRadios(pseoData);
      initFlowsOptions();
      initFlowsDisplay();
    }

    $j33("#gradcohort-dropdown").removeClass("show");

    return false;
  });

  // click the url if it's in the parameters
  if (checkURLParam("gradcohort")) {
    clickURLParam("gradcohort");
  }
  // try to maintain the user selected cohort if available
  if (
      gradcohortsMetadata.some(
          obj => obj.grad_cohort_id === pseoData.grad_cohort_id
      )
  ) {
    $j33(
        `#gradcohort-dropdown > .dropdown-list > #${pseoData.grad_cohort_id}`
    ).trigger("click");
  } else {
    // otherwise select the best cohort defined above
    $j33(
        "#gradcohort-dropdown > .dropdown-list > #" +
        bestGradCohort.grad_cohort_id
    ).trigger("click");
  }
  removeFocus();
}

function setupInstitutionDropdown(institutionsMetadata) {
  $j33("#institution-dropdown > .dropdown-list").empty(); // clear the list just incase
  $j33("#institution-dropdown > form > input").val("");

  // put the margins at the top
  const institutionMarginsSort = institutionsMetadata.filter(
      obj => obj.institution.length === 2
  ).sort((a, b) => a.institution_label.localeCompare(b.institution_label));

  // put the non margins at the bottom
  const institutionNonmarginsSort = institutionsMetadata.filter(
      obj => obj.institution.length !== 2
  ).sort((a, b) => a.institution_label.localeCompare(b.institution_label));

  let institutionLabelSort = institutionMarginsSort.concat(institutionNonmarginsSort)

  institutionLabelSort.forEach(function (obj) {
    let dropdownElement = document.createElement("a");
    dropdownElement.className = "dropdown-item";
    dropdownElement.id = obj.institution;
    dropdownElement.innerHTML = obj.institution_label;
    $j33("#institution-dropdown > .dropdown-list").append(dropdownElement);
  });

  let noDataElement = createNoDataDropdownElement();
  $j33("#institution-dropdown > .dropdown-list").append(noDataElement);

  let dropdownButton = $j33("#institution-dropdown-button");
  activateDropdownButton(dropdownButton);

  $j33("#institution-dropdown > .dropdown-list > a").click(function () {
    pseoData.institution = this.id;
    // change the dropdown to show the institution
    dropdownButton.html(this.innerHTML);
    updateURL("institution", this.id);

    //pass the degreelevel metadata to the setup func
    let degreelevelsMetadata = institutionsMetadata.find(
        obj => obj.institution === this.id
    ).degree_levels;
    setupDegreeLevelDropdown(degreelevelsMetadata);

    // hide the institution list
    $j33("#institution-dropdown").removeClass("show");

    return false;
  });

  // click the url if it's in the parameters
  if (checkURLParam("institution")) {
    clickURLParam("institution");
  }
  // try to maintain the user selected institution if available
  else if (
      institutionsMetadata.some(obj => obj.institution === pseoData.institution)
  ) {
    $j33(
        `#institution-dropdown > .dropdown-list > #${pseoData.institution}`
    ).trigger("click");
  } else {
    // if a default university is listed for the state
    // and that university is available in the institution-dropdown select
    // else pick the first from the list
    let selectedState = $j33("#state-dropdown-button").text();
    if (
        config.universityDefault.hasOwnProperty(selectedState) &&
        $j33(
            "#institution-dropdown > .dropdown-list > #" +
            config.universityDefault[selectedState]
        ).length
    ) {
      $j33(
          "#institution-dropdown > .dropdown-list > #" +
          config.universityDefault[selectedState]
      ).trigger("click");
      // otherwise select first available
    } else {
      $j33("#institution-dropdown > .dropdown-list :first-child").trigger(
          "click"
      );
    }
  }
  removeFocus();
}

function setupDegreeLevelDropdown(degreelevelsMetadata) {
  $j33("#degreelevel-dropdown > .dropdown-list").empty();
  $j33("#degreelevel-dropdown > form > input").val("");

  // order the degrees using the config
  var sortedDegrees = [];
  config.degreeOrder.forEach(function (ord) {
    degreelevelsMetadata.some(function (obj) {
      if (obj.degree_level_label == ord) {
        sortedDegrees.push(obj);
      }
    });
  });

  // add to dropdown list
  sortedDegrees.forEach(function (value) {
    let dropdownElement = document.createElement("a");
    dropdownElement.className = "dropdown-item";
    dropdownElement.id = value.degree_level;
    dropdownElement.innerHTML = value.degree_level_label;
    $j33("#degreelevel-dropdown > .dropdown-list").append(dropdownElement);
  });

  let noDataElement = createNoDataDropdownElement();
  $j33("#degreelevel-dropdown > .dropdown-list").append(noDataElement);

  let dropdownButton = $j33("#degreelevel-dropdown-button");
  activateDropdownButton(dropdownButton);

  $j33("#degreelevel-dropdown > .dropdown-list > a").click(async function () {
    pseoData.degree_level = this.id;

    // if flows or
    // if earnings and MA, PhD-Research disable detailed programs
    if (pseoData.dataType === "flows" ||
        (pseoData.dataType === "earnings" &&
            (pseoData.degree_level === "07" || pseoData.degree_level === "17"))
    ) {
      allowDetailedPrograms(false)
    } else {
      allowDetailedPrograms(true)
    }

    // change the dropdown button to show the selected degree
    dropdownButton.html(this.innerHTML);
    updateURL("degreelevel", this.id);

    //pass the gradcohorts metadata to the setup func
    let gradcohortsMetadata = degreelevelsMetadata.find(
        obj => obj.degree_level === this.id
    ).grad_cohorts;
    setupCohortDropdown(gradcohortsMetadata);

    $j33("#degreelevel-dropdown").removeClass("show");

    return false;
  });
  // click the url if it's in the parameters
  if (checkURLParam("degreelevel")) {
    clickURLParam("degreelevel");
  }
  // try to maintain the user selected degree_level if available
  else if (
      degreelevelsMetadata.some(obj => obj.degree_level === pseoData.degree_level)
  ) {
    $j33(
        `#degreelevel-dropdown > .dropdown-list > #${pseoData.degree_level}`
    ).trigger("click");
  } else {
    if (
        degreelevelsMetadata.some(
            obj => obj.degree_level_label === "Baccalaureate"
        )
    ) {
      $j33("#degreelevel-dropdown > .dropdown-list > #05").trigger("click");
    } else if (
        degreelevelsMetadata.some(obj => obj.degree_level_label === "Associates")
    ) {
      $j33("#degreelevel-dropdown > .dropdown-list > #03").trigger("click");
    } else {
      $j33("#degreelevel-dropdown > .dropdown-list :first-child").trigger(
          "click"
      );
    }
  }
  removeFocus();
}

function setupStateDropdown(availabilityMetadata, dataType) {
  if (availabilityMetadata[dataType + "_availability"] === undefined) {
    return; // early return if this is called with no metadata
  }
  // sort state list and add to dropdown
  $j33("#state-dropdown > form > input").val("");

  // get all states not including "00" (Online-Only)
  let stateAvailability = availabilityMetadata[dataType + "_availability"]
      .filter(obj => obj.institution_statefips !== "00");

  // add all states in alphabetical order
  stateAvailability.sort((a, b) =>
          a.institution_statefips_label.localeCompare(b.institution_statefips_label)
      )
      .forEach(function (obj) {
        let dropdownElement = document.createElement("a");
        dropdownElement.className = "dropdown-item";
        dropdownElement.id = obj.institution_statefips;
        dropdownElement.innerHTML = obj.institution_statefips_label;
        $j33("#state-dropdown > .dropdown-list").append(dropdownElement);
      });

  // add the 00 - Online-Only "state" to the bottom
  let onlineOnly = availabilityMetadata[dataType + "_availability"].find(
      obj => obj.institution_statefips === "00"
  );
  if (onlineOnly) {
    let dropdownElement = document.createElement("a");
    dropdownElement.className = "dropdown-item";
    dropdownElement.id = onlineOnly.institution_statefips;
    dropdownElement.innerHTML = onlineOnly.institution_statefips_label;
    $j33("#state-dropdown > .dropdown-list").append(dropdownElement);
  }

  let noDataElement = createNoDataDropdownElement();
  $j33("#state-dropdown > .dropdown-list").append(noDataElement);

  activateDropdownButton($j33("#state-dropdown-button"));

  $j33("#state-dropdown > .dropdown-list > a").click(async function (
      event,
      addToUrl = true
  ) {
    // add to the global filter
    pseoData.institution_statefips = this.id;

    // add to the url
    if (addToUrl) {
      updateURL("state", this.id);
    }

    $j33("#state-dropdown-button").text(this.innerHTML);
    //pass the state availability metadata to the institution dropdown
    let institutionsMetadata = availabilityMetadata[
    dataType + "_availability"
        ].find(obj => obj.institution_statefips === this.id).institutions;
    setupInstitutionDropdown(institutionsMetadata);

    $j33("#state-dropdown").removeClass("show");

    return false;
  });

  // select the state parsed by the URL
  if (checkURLParam("state")) {
    clickURLParam("state");
  }
  // maintain the degree selection if possible when toggling data type
  else if (
      availabilityMetadata[dataType + "_availability"].some(
          obj => obj.institution_statefips === pseoData.institution_statefips
      )
  ) {
    $j33(
        `#state-dropdown > .dropdown-list > #${pseoData.institution_statefips}`
    ).trigger("click", true);
  } else {
    $j33("#state-dropdown > .dropdown-list > #" + config.defaultState).trigger(
        "click",
        true
    );
  }
  removeFocus();
}

function cleanURLSearchParams() {
  // removes any unexpected/unused key parameters from the query
  let recognizedKeys = [
    "type",
    "state",
    "institution",
    "degreelevel",
    "gradcohort",
    "specificity",
    // "compare" added below
    "filter",
    "program"
  ];

  // set data type specific keys
  if (SEARCH_PARAMS.has("type")) {
    if (SEARCH_PARAMS.get("type") === "earnings") {
      recognizedKeys.push("compare");
    } else if (SEARCH_PARAMS.get("type") === "flows") {
      recognizedKeys.push("destination");
      recognizedKeys.push("display");
    }
  }

  for (let value of SEARCH_PARAMS.keys()) {
    if (!recognizedKeys.includes(value)) {
      deleteFromURL(value);
    }
  }
}

function removeFocus() {
  $j33("label").blur(); // remove any initial focus
  $j33("button").blur();
}

$j33(function () {
  $j33(".preloader").fadeOut("slow");
  cleanURLSearchParams();
  initDataTypeToggle();
  initTwoToggle();
  initRadioLabel();
  initCipLevel();
  initD3Chart();
  initChartType(pseoData);
  pseoData.animationTimer = drawBarLoader(pseoData.animationTimer);
  clearAxis();
  removeFocus();
  Promise.all([
    performQuery(getEarningsMetadataQuery()),
    performQuery(getFlowsMetadataQuery())
  ])
      .then(data => {
        if (data.length != 2) {
          throw "Missing PSEO availability metadata";
        } else {
          // place data in pseoData object for reuse
          pseoData.metadata.earnings_availability = data.find(obj =>
              obj.data.hasOwnProperty("earnings_availability")
          ).data.earnings_availability;
          pseoData.metadata.flows_availability = data.find(obj =>
              obj.data.hasOwnProperty("flows_availability")
          ).data.flows_availability;
          setupStateDropdown(pseoData.metadata, "earnings");
        }
      })
      .catch(err => {
        console.log(err);
      });
});
